import { Directive, ElementRef, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { BehaviorSubject, debounceTime, Subject, takeUntil } from 'rxjs';
import { getFirstArrayValue } from '../utils';

const DEBOUNCE_TIME = 100;

@Directive({
  selector: '[appOutOfScreen]',
})
export class OutOfScreenDirective implements OnInit, OnDestroy {
  @Output() appOutOfScreen = new EventEmitter<boolean>();

  private outOfScreen$ = new BehaviorSubject<boolean>(false);
  private ngDestroy$ = new Subject<void>();

  private intersectionObserver: IntersectionObserver | undefined;
  private intersectionObserverOptions: IntersectionObserverInit = {
    root: null,
    rootMargin: '0px',
    threshold: 0.5,
  };

  constructor(private elementRef: ElementRef<HTMLDivElement>) {}

  ngOnInit(): void {
    this.imageIsOutOfScreen();
    this.intersectionObserver = new IntersectionObserver((entries) => this.handleIntersection(entries), this.intersectionObserverOptions);
    this.intersectionObserver.observe(this.elementRef.nativeElement);
  }

  ngOnDestroy(): void {
    this.intersectionObserver?.disconnect();
    this.ngDestroy$.next();
    this.ngDestroy$.complete();
  }

  private handleIntersection(entries: IntersectionObserverEntry[]): void {
    if (getFirstArrayValue(entries)?.isIntersecting) {
      this.outOfScreen$.next(false);
    } else {
      this.outOfScreen$.next(true);
    }
  }

  private imageIsOutOfScreen(): void {
    this.outOfScreen$.pipe(takeUntil(this.ngDestroy$), debounceTime(DEBOUNCE_TIME)).subscribe((outOfScreen) => {
      this.appOutOfScreen.emit(outOfScreen);
    });
  }
}
